export function SourceViewSkeleton() {
    return (
        <div className="h-full flex flex-col relative overflow-hidden pt-14">
            <div className="flex-1 overflow-y-auto scrollbar-hide">
                <div className="flex flex-col gap-6 pt-8 pb-24 max-w-content mx-auto">
                    <div className="w-full aspect-video skeleton-item-container rounded-lg" />

                    <div className="h-[32px] w-[300px] skeleton-item-container rounded-md" />

                    <div className="h-[320px] w-full skeleton-item-container rounded-xl" />
                </div>
            </div>
        </div>
    );
}
